(function () {
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

  function getParamValue(key) {
    const urlVal = new URLSearchParams(window.location.search).get(key);
    if (urlVal) {
      localStorage.setItem(key, urlVal);
      return urlVal;
    }
    return localStorage.getItem(key) || '';
  }

  function fillFields() {
    keys.forEach((key) => {
      const value = getParamValue(key);
      if (!value) return;

      const inputs = document.querySelectorAll(
        `input[placeholder="${key}"], input[name="${key}"], input[id="${key}"]`
      );

      inputs.forEach((input) => {
        input.setAttribute('value', value); // important for POWR
        input.value = value;
        console.log("Setting", key, "to", value); // debug line
      });
    });
  }

  function waitForInputsAndFill() {
    const checkExist = setInterval(() => {
      const found = keys.some(key => document.querySelector(`input[placeholder="${key}"]`));
      if (found) {
        clearInterval(checkExist);
        fillFields();
      }
    }, 300);
    setTimeout(() => clearInterval(checkExist), 5000);
  }

  document.addEventListener("DOMContentLoaded", waitForInputsAndFill);
})();
